import { ReactNode } from "react";
import "./Banner.css";
import "./BannerResponsive.css";

function Banner({ children }: { children: ReactNode }) {
  return (
    <div className="banner">
      <div className="overlay"></div>
      <h1 className="d-flex gap-3">{children}</h1>
    </div>
  );
}

export default Banner;
